/**
 * Count the number of system messages that should cause alerts and badges
 *
 * @param {object} systemMessages
 * @returns {number}
 */
const getSystemMessageAlertCount = (systemMessages = {}) => {
    return (
        (systemMessages.InvoiceOverdue ? 1 : 0) +
        (systemMessages.PayoutFailed ? 1 : 0) +
        (systemMessages.PayoutReadyBankAccountMissing ? 1 : 0) +
        (systemMessages.SwishNumberMissing ? 1 : 0) +
        (systemMessages.HyperwalletPayeeVerificationRequired ? 1 : 0) +
        (systemMessages.BankIdNeverVerified ? 1 : 0)
    );
};

export { getSystemMessageAlertCount };
